import { useMemo } from 'react';
import qrcode from 'qrcode-generator';

/** A QR code as crisp SVG: scales to any size and prints sharply. */
export function QrCode({ text, size = 132, label = "QR code holding this card's record" }: {
  text: string; size?: number; label?: string;
}) {
  const svg = useMemo(() => {
    const qr = qrcode(0, 'M');
    qr.addData(text);
    qr.make();
    const n = qr.getModuleCount();
    let d = '';
    for (let y = 0; y < n; y++) for (let x = 0; x < n; x++) if (qr.isDark(y, x)) d += `M${x + 4} ${y + 4}h1v1h-1z`;
    return { d, size: n + 8 };
  }, [text]);
  return (
    <svg role="img" aria-label={label} width={size} height={size}
      viewBox={`0 0 ${svg.size} ${svg.size}`} shapeRendering="crispEdges" style={{ flexShrink: 0 }}>
      <rect width={svg.size} height={svg.size} fill="#fff" />
      <path d={svg.d} fill="#000" />
    </svg>
  );
}
